import React, {
  FC,
  Fragment,
  MutableRefObject,
  useEffect,
  useState,
  useRef,
} from 'react';
import { createPortal } from 'react-dom';
import { createGlobalStyle, css } from 'styled-components';

/**
 * It creates a Portal that allows to append Tooltip content outside of the tooltip component irtself
 *
 * @param {ReactNode} children Tooltip content
 */
export const TooltipPortal: FC = ({ children }) => {
  const [isNoScroll, setNoScroll] = useState(false);
  const portalElement = document.createElement('div');
  portalElement.setAttribute(
    'style',
    'position: absolute; top: 0; left: 0; width: 100%',
  );

  const portalRef: MutableRefObject<HTMLElement> = useRef(portalElement);

  useEffect(() => {
    setNoScroll(true);
    document.body.appendChild(portalRef.current);

    return () => {
      if (portalRef?.current?.parentElement) {
        setNoScroll(false);
        portalRef?.current?.parentElement.removeChild(portalRef?.current); // eslint-disable-line react-hooks/exhaustive-deps
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return createPortal(
    <Fragment>
      <GlobalStyle isNoScroll={isNoScroll} />
      {children}
    </Fragment>,
    portalRef.current,
  );
};

const CSSNoScroll = css`
  overflow: hidden;
`;

const GlobalStyle = createGlobalStyle<{ isNoScroll: boolean }>`
  body {
    ${({ isNoScroll }) => isNoScroll && CSSNoScroll};
  }
`;
